// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3c3D9","title":"BackImages_title__1EUln","images":"BackImages_images__2lFvO"};